/*jslint browser: true */
/*global window, require */

module.exports = function()
{
	'use strict';
	const self = this || {};
	const winAlias = window;

	self.hasPageObject = false;

	let ulid = require('ulid').ulid;

	let commands = require('./commands.js');
	let storage = require('./storage.js');
	self.transport = require('./transport.js');

	self.pushAll = function (items)
	{
		for (var idx = 0; idx < items.length; idx++)
		{
			self.push(items[idx]);
		}
	};

	self.push = function(item)
	{
		let cmd = item.shift();

		if (!commands.hasOwnProperty(cmd))
			return false;

		commands[cmd](self, item);
	};

	self.queue = require('./queue.js');
	self.queue.setTracker(self);
	self.queue.setStorage(storage);
	self.queue.addDefault('p', ulid());

	let uid = storage.getAny('u');
	if (!uid || uid.length != 26)
		uid = ulid();
	storage.setStorage('u', uid);
	storage.setCookie('u', uid);
	self.queue.addDefault('u', uid);

	let sid = storage.getAny('s');
	if (!sid || sid.length != 26)
		sid = ulid();
	storage.setCookieTemp('s', sid);
	self.queue.addDefault('s', sid);

	winAlias.addEventListener("load", function (e) {
		self.push(["load"]);
	});
	winAlias.addEventListener("unload", function (e) {
		self.push(["unload"]);
		self.queue.flush();
	});

	return self;
}();
